import React from 'react';
import { Button } from 'antd';
import { restApi } from '../../../apis';
import dayjs from 'dayjs';

const LectureDeleteModal = (props) => {
  const setGModal = props.setGModal;
  // const setLoading = props.setLoading;
  const setSorts = props.setSorts;
  const lectureId = props.lectureId;

  const styles = {
    container: {
      display: 'flex',
      width: '59.3rem',
      flexDirection: 'column',
      // justifyContents: 'space-between',
      // justifyContent: 'center',
      background: '#FFFFFF',
      boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
      borderRadius: 6,
      padding: '3rem',
    },
    row: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',
      padding: 0,
    },
  };
  return (
    <div style={{ ...styles.container }}>
      해당 시퀀스는 밸런스피터 데이터베이스와 생성자 디바이스 모두에서
      삭제됩니다. 또한, 데이터베이스에서 한번 삭제한 시퀀스는 다시 복구할 수
      없습니다. 정말 해당 강의를 삭제하시겠습니까?
      <div style={{ ...styles.row, marginTop: 20 }}>
        <Button
          key="delete"
          type="primary"
          // loading={loading}
          onClick={async (e) => {
            //삭제
            await restApi.delete(`/admin/lecture/${lectureId}`);
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
            setSorts((prev) => {
              return {
                ...prev,
                reload: new Date(),
              };
            });
          }}
          danger
        >
          {`삭제`}
        </Button>
        <div style={{ marginLeft: 20 }} />
        <Button
          key="cancel"
          type="default"
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >
          {`취소`}
        </Button>
      </div>
    </div>
  );
};

export default LectureDeleteModal;
